import { HexPoint } from '@/core/types/battle.types';
import * as PIXI from 'pixi.js';
// import { BattleHex } from '../../core/battle/battleHex';
import footstepsPng from '@assets/footsteps.png'

export class PathRenderer {
    public container: PIXI.Container;
    private pool: PIXI.Sprite[] = [];
    private activeCount: number = 0;
    private stepTexture: PIXI.Texture | null = null;
    private readonly STEP_DISTANCE = 64;

    constructor(parent: PIXI.Container) {
        this.container = new PIXI.Container();
        this.container.eventMode = 'none';
        this.container.interactiveChildren = false;
        parent.addChild(this.container);

        PIXI.Assets.load(footstepsPng);
    }

    public drawPathFromPoints(rawPoints: {x: number, y: number}[], isZoc: boolean) {
        this.clear();

        if (!this.stepTexture) {
            this.stepTexture = PIXI.Assets.get(footstepsPng);
        }

        if (!this.stepTexture || rawPoints.length < 2) return;

        let distanceTraveled = 0;
        for (let i = 0; i < rawPoints.length - 1; i++) {
            const p1 = rawPoints[i]!;
            const p2 = rawPoints[i + 1]!;

            const dx = p2.x - p1.x;
            const dy = p2.y - p1.y;
            const segmentDist = Math.hypot(dx, dy);
            distanceTraveled += segmentDist;

            if (distanceTraveled >= this.STEP_DISTANCE) {
                const angle = Math.atan2(dy, dx);
                this.renderStep(p2.x, p2.y, angle, isZoc);
                distanceTraveled = 0;
            }
        }
        
    }

    private renderStep(x: number, y: number, angle: number, isZoc: boolean) {
        let step = this.pool[this.activeCount];

        if (!step) {
            step = new PIXI.Sprite(this.stepTexture!);
            step.anchor.set(0.5);
            this.container.addChild(step);
            this.pool.push(step);
        }

        step.x = x;
        step.y = y;
        step.rotation = angle + Math.PI / 2;
        step.visible = true; // Повертаємо видимість
        
        if (isZoc) {
            step.tint = 0x8b0000;
            step.alpha = 0.6;
        } else {
            step.tint = 0xffffff;
            step.alpha = 0.4;
        }

        this.activeCount++;
    }

    public getSplinePoints(points: HexPoint[], isHill: boolean = false): HexPoint[] {
        if (points.length < 2) return [...points];
    
        const splinePoints: HexPoint[] = [];
        const hillOffset = 20; // На сколько пикселей финал будет выше начала
    
        const catmullRom = (p0: number, p1: number, p2: number, p3: number, t: number): number => {
            const t2 = t * t; 
            const t3 = t2 * t;
            return 0.5 * ((2 * p1) + (-p0 + p2) * t + (2 * p0 - 5 * p1 + 4 * p2 - p3) * t2 + (-p0 + 3 * p1 - 3 * p2 + p3) * t3);
        };
    
        for (let i = 0; i < points.length - 1; i++) {
            const p1 = points[i]!; 
            const p2 = points[i + 1]!;
            const p0 = points[i - 1] ?? p1;
            const p3 = points[i + 2] ?? p2;
    
            for (let t = 0; t <= 1; t += 0.5) {
                let x = catmullRom(p0.x, p1.x, p2.x, p3.x, t);
                let y = catmullRom(p0.y, p1.y, p2.y, p3.y, t);
    
                if (isHill) {
                    const totalProgress = (i + t) / (points.length - 1);
                    
                    y -= totalProgress * hillOffset;
                }
    
                splinePoints.push({ x, y });
            }
        }
        return splinePoints;
    };
    

    public clear() {
        for (let i = 0; i < this.activeCount; i++) {
            if (this.pool[i]) this.pool[i]!.visible = false;
        }
        this.activeCount = 0;
    }

    public destroy() {
        this.pool.forEach(s => s.destroy());
        this.pool = [];
        this.container.destroy({ children: true });
    }
}